import React, { FunctionComponent } from 'react';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import { ReactComponent as ArrowUp } from '../assets/arrow-up.svg';

interface CollapsibleDrawerArrowProps {
  isOpen: boolean;
}

const ArrowContainer = styled(Box)`
  transition: transform 0.2s ease;
  height: 100%;
`;

const CollapsibleDrawerArrow: FunctionComponent<
CollapsibleDrawerArrowProps> = ({ isOpen }: CollapsibleDrawerArrowProps) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
  >
    <ArrowContainer sx={{
      transform: isOpen ? 'rotate(0deg) translate(0px, -15%)' : 'rotate(180deg) translate(0px, -15%)',
    }}
    >
      <ArrowUp />
    </ArrowContainer>
  </Flex>
);

export type {
  CollapsibleDrawerArrowProps,
};

export default CollapsibleDrawerArrow;
